import PropTypes from "prop-types";
import * as React from "react";
import { Box } from "@material-ui/core";
import { Form, InfoTooltip } from "../../../theme";
import * as styles from "../styles";
import useSWR from "swr";
import { fetcher, useActiveInfluencer } from "../../../hooks";

export function usePosition(productId) {
  const activeInfluencer = useActiveInfluencer();

  const params = new URLSearchParams({
    product_id: productId,
    tag_string: activeInfluencer?.productTagString,
  }).toString();

  const { data, error, mutate } = useSWR(
    activeInfluencer?.isGroupShop || !productId
      ? `/api/productTag/position?${params}`
      : null,
    fetcher,
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
}

async function updatePosition(productId, tagString, position) {
  const response = await fetch(`/api/productTag/position`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ productId, tagString, position }),
  });

  if (!response.ok) {
    throw new Error("Failed to update position");
  }

  return response.json();
}

export default function CollectionPosition({ tagString, productId }) {
  const { data, mutate, isLoading } = usePosition(productId);

  const [workingPosition, setWorkingPosition] = React.useState(
    data?.tag?.position || 0,
  );

  return (
    <Box display="flex" flexDirection="column" gridGap="8px" my={1}>
      <div>
        <styles.Label>
          <span>Shop Position</span>
          <InfoTooltip
            size="small"
            content="Lower number to move to the top of the shop, higher to move to the bottom."
          />
        </styles.Label>
      </div>

      <div>
        <Form.Input
          type="text"
          size="small"
          variant="outlined"
          disabled={isLoading}
          value={workingPosition}
          inputProps={{
            type: "number",
            min: -99999,
            max: 99999,
            size: 3,
            maxLength: 5,
            step: 1,
          }}
          onChange={(evt) => {
            setWorkingPosition(evt.target.value);
          }}
          onBlur={async (evt) => {
            const trimmed = evt.target.value.trim();

            if (!trimmed) {
              return;
            }

            const newNumber = Number.parseInt(trimmed, 10);

            if (Number.isNaN(newNumber)) {
              return;
            }

            const { tag } = await updatePosition(
              productId,
              tagString,
              newNumber,
            );

            mutate({ ...data, tag });
          }}
        />
      </div>
    </Box>
  );
}

CollectionPosition.propTypes = {
  tagString: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
};
